// ABOUTME: Confirmation dialog for regenerating a child's access token
// ABOUTME: Warns that old URL will stop working after regeneration

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography
} from '@mui/material';
import type { ChildAccessToken } from '../types';

interface RegenerateTokenDialogProps {
  open: boolean;
  token: ChildAccessToken | null;
  regenerating: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const RegenerateTokenDialog: React.FC<RegenerateTokenDialogProps> = ({
  open,
  token,
  regenerating,
  onClose,
  onConfirm
}) => {
  if (!token) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      data-testid="regenerate-token-confirmation"
    >
      <DialogTitle>Regenerate Access URL</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to regenerate the access URL for <strong>{token.childName}</strong>&apos;s dashboard?
        </Typography>
        <Typography sx={{ mt: 2, color: 'text.secondary' }}>
          This will immediately invalidate the current URL and any devices using it will lose access
          until you provide the new URL.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={regenerating}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="warning"
          variant="contained"
          disabled={regenerating}
        >
          {regenerating ? <CircularProgress size={20} /> : 'Regenerate URL'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RegenerateTokenDialog;
